import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CertificateDto } from '@app/_api/dto';
import { ToastService } from '@app/core/services/toast.service';
import { DialogService } from '@app/core/services/dialog.service';
import { BaseApi } from '@app/core/services/api/base.api';
import { UUID } from '@app/_api/identifyable';

export type CertificateCreateRequest = Pick<CertificateDto, 'title' | 'issuer'>;

@Service()
export class CertificateApi extends BaseApi {
  readonly createCertificateSuccessMessage = 'Zertifikat erfolgreich angelegt';
  readonly createCertificateErrorMessage = 'Fehler beim Anlegen des Zertifikates';

  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/certificate', toastService, dialog);
  }

  createCertificate(certificateDto: CertificateCreateRequest) {
    return this.handleHttp<CertificateDto>(this.http.post<CertificateDto>(this.buildPath(''), certificateDto), {
      error: this.createCertificateErrorMessage,
      success: this.createCertificateSuccessMessage,
    });
  }

  getAllCertificates() {
    return this.handleHttp<CertificateDto[]>(this.http.get<CertificateDto[]>(this.buildPath('/all')), {
      error: 'Fehler beim Laden der Zertifikate',
    });
  }

  getById(certificateId: UUID): Observable<CertificateDto> {
    return super.GET<CertificateDto>(`/${certificateId}`);
  }
}
